/**
 * @file コンポーネント：フル動画ページ機器広告問い合わせ成功モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "submit",
                    onClick: (e) => {
                        e.preventDefault();
                        props.setIsOpenModalAdSuccess(false);
                    },
                    text: localized["Label.Ok"],
                },
            ]}
            content={[
                <React.Fragment key="content">
                    <Paragraph
                        onColor="white"
                        text={localized["Message.SentYourInforamtion"]}
                    />
                    <Paragraph
                        onColor="white"
                        text={localized["Message.WillCloseThisModal"]}
                    />
                </React.Fragment>,
            ]}
            hasButtonClose={true}
            headline={localized["Label.Success"]}
            isShow={props.isOpenModalAdSuccess}
            setIsShow={props.setIsOpenModalAdSuccess}
        />
    );
};
